export const capMaxValue = (value, maxValue) => {
  return value && typeof value === 'number' && value > maxValue
    ? `${maxValue}+`
    : value;
};
